import {
  find, prop, propEq,
} from 'ramda';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useCompanies from './useCompanies';
import usePois from './usePois';

const useUser = () => {
  const { data, error, loading } = useSelector(prop('user'));
  const { companies } = useCompanies();
  const { pois } = usePois();

  const company = useMemo(() => {
    if (!companies.data?.length || error || loading) {
      return null;
    }
    return find(propEq('_id', data.company), companies.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies.data?.length, error, loading]);


  const poi = useMemo(() => {
    if (!pois.data?.length || error || loading) {
      return null;
    }

    return find(propEq('_id', data.poi), pois.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pois.data?.length, error, loading]);

  return {
    data: {
      ...data,
      poi,
      company,
    },
    error,
    loading: loading || companies?.loading || pois?.loading,
  };
};

export default useUser;
